import React, { useState, useRef, useEffect } from "react";
import "./resources.css";
import { Carousel } from "../../components/Carousel/Carousel1/Carousel";
import vivre from "../../assets/Home/Whitepaper1/img20.jpg";
import sia from "../../assets/Home/Whitepaper22/img22.jpg";

import styled from "styled-components";
import Blogs from "./Blogs";
import NewFooter from "../../components/NewFooter/NewFooter";
import { Typography } from "@mui/material";
import { PDF_URL } from "./Contants";
import AOS from 'aos';
import 'aos/dist/aos.css';

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: 900px;
  border-radius: 16px;
  overflow: hidden;
  margin: 20px auto;

  /* Base icy translucency */
  background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(200, 230, 255, 0.2) 100%
    ),
    url('https://www.transparenttextures.com/patterns/ice.png'); /* Ice texture */
  background-size: cover;
  background-blend-mode: overlay;

  backdrop-filter: blur(18px) saturate(180%);
  -webkit-backdrop-filter: blur(18px) saturate(180%);

  /* Light frosty border */
  border: 1px solid rgba(255, 255, 255, 0.4);

  /* Inner glow to simulate frozen edge */
  box-shadow:
    inset 0 0 20px rgba(255, 255, 255, 0.5),
    0 8px 32px rgba(31, 38, 135, 0.3);

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;




const CardSection = styled.div`
  flex: 1;
  padding: 24px;
  box-sizing: border-box;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

const Input = styled.input`
  padding: 12px 16px;
  margin: 8px 0;
  width: 100%;
  font-size: 1rem;
  background: #f9f9f9;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
    background: #fff;
  }

  &::placeholder {
    color: #aaa;
  }
`;

const LeftSection = styled(CardSection)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #3327b9;
  text-align: start;
  background-color: transparent;
`;

const Title = styled.h2`
  margin: 0 0 12px;
  font-size: 1.6em;
  font-weight: 600;
  color:#fff;
`;

const Description = styled.p`
  margin: 0 0 20px;
  font-size: 1em;
  color: #ffff;
`;

const Para = styled.p`
  margin: 0 0 20px;
  font-size: 1em;
  color: #fff;
`;

const Button = styled.button`
  padding: 12px 20px;
  margin-top: 12px;
  width: 40%;
  background-color: #6054e4;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background-color: #4d44c2;
  }
`;

export default function Resources() {
    const formRef = useRef(null);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState();
    const [activeSlide, setActiveSlide] = useState("");
     const whitepapers = [
        {
            id: "0",
            src: sia,
            alt: "image1 for carousel",
        },
        {
            id: "1",
            src: vivre,
            alt: "image 2 for carousel",
        },
    ];
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      once: false,     // whether animation should happen only once
      offset: 150,    // trigger point (px) before element enters viewport
    });
  }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const handleSubmit = (e) => {
        e.preventDefault();
        const phoneNumberPattern = /^\d{10}$/;
        if (!phoneNumberPattern.test(phoneNumber)) {
            alert("Please enter a valid 10-digit phone number.");
            return; 
        }
       
        // Handle form submission logic here
        console.log("Name:", name);
        console.log("Email:", email);
        downloadInvoice()
    };
const handleItemSelect = (index) => {
    console.log('Selected Index:', index);
    
    if (index === 0) {
        setActiveSlide("whitepaper1");
    } else if (index === 1) {
        setActiveSlide("whitepaper2");
    }
    
    // Scroll logic
   
};
    const handleSlideChange = (index) => {
       
        
        console.log("Active Slide Index:", index);
    };

   
    const downloadInvoice = () => {
        console.log(activeSlide, name, email, companyName, phoneNumber);

        fetch(
            PDF_URL,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: activeSlide,
                    name: name,
                    email: email,
                    companyName: companyName,
                }),
            }
        )
        .then((response) => {
            if (!response.ok) {
                // Handle non-2xx HTTP responses
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }
            return response.json();
        })
        .then((data) => {
            console.log("Response data:", data);
            if (data?.responseCode == 1) {
                downloadPDF(data,activeSlide);
            } else {
                console.log("Error in response:", data);
            }
        })
        .catch((error) => {
            // Handle network errors or issues with the fetch request
            console.error("API call failed:", error);
            alert("Failed to download the whitepaper. Please try again later.");
        });
        
    };

    const downloadPDF = (responseData, activeSlide) => {
        const byteCharacters = atob(responseData?.file);
        const byteNumbers = new Array(byteCharacters?.length);
        for (let i = 0; i < byteCharacters?.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
            type: "application/pdf",
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = activeSlide==="whitepaper1"?"whitepaper1":"whitepaper2" + ".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };


    return (
        <div className="res-continer">
            <div  data-aos="zoom-in">
            <div className="res-section1" >
                <div className="res-title">
                                          <Typography
               data-aos="zoom-in"
               style={{
                 display: "flex",
                 justifyContent: "center",
                 fontSize: "39px",
                 fontWeight: "800",
                 fontFamily: "system-ui",
                 color: "#6054E4",
            
               }}
             >Resources</Typography>
                </div>
                {/* <div className="res-description"> */}
                    {/* <p>
                        We worked with multiple clients and ensured that our work has met
                        their vision for their products. Here are some examples of some of
                        our best work.
                    </p> */}
                {/* </div> */}

                <div className="form-carousel" >
                
                    <Carousel data={whitepapers} onItemSelect={handleItemSelect} page={"resource"} />
                    <div  data-aos="slide-up" className="form-section" ref={formRef} >
                        <CardContainer>
                            <LeftSection>
                                <Title>Want access to Whitepaper?</Title>
                                <Title>Sign up today!</Title>
                                <Description>
                                    Sign up today! Fill the form and we’ll get in touch with you
                                    about how you can integrate Whitepaper with your business.
                                </Description>
                            </LeftSection>
                            {/* <Divider /> */}
                            <div className="formDiv">
                            <CardSection style={{padding:"20px"}}>
                                <form onSubmit={handleSubmit} >
                                    <Input
                                        type="text"
                                        placeholder="Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                    />
                                    <Input
                                        type="email"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                    <Input
                                        type="text"
                                        placeholder="Company Name"
                                        value={companyName}
                                        onChange={(e) => setCompanyName(e.target.value)}
                                        required
                                    />
                                    <Input
                                        type="text"
                                        placeholder="Phone Number"
                                        value={phoneNumber}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        required
                                    />
                                    <Button type="submit">Submit</Button>
                                </form>
                            </CardSection>
                            </div>
                        </CardContainer>
                    </div>
                </div>
            </div>
            <div >
            <div className="res-section2">
                <div className="res-title">
                    <h3>Blogs</h3>
                </div>
                <div className="res-description">
                    <p>
                        Keep up with the latest news in the OTT industry and also stay to
                        date with latest news about our Company.
                    </p>
                </div>
            </div>
            <div className="blogs">
                <Blogs />
            </div>
            </div>
            
            {/* <div className="press">
                <div className="press-title">
                    <h3>Press Releases</h3>
                </div>
                <div className="press-description">
                    <p>
                        Keep up with the latest news in the OTT industry and also stay to
                        date with latest news about our Company.
                    </p>
                </div>
                <div className="release-container">
                    <div className="first-release">
                        <div className="first-release-title">
                            <h3>Lorem ipsum dolor sit amet, consectetur </h3>
                        </div>
                        <div className="first-release-description">
                            <p>
                                Keep up with the latest news in the OTT industry and also stay
                                to date with latest news about our Company.
                            </p>
                            <button className="readmore-btn">Read More</button>
                        </div>
                    </div>
                    <div className="divider"></div>
                    <div className="first-release">
                        <div className="first-release-title">
                            <h3>Lorem ipsum dolor sit amet, consectetur </h3>
                        </div>
                        <div className="first-release-description">
                            <p>
                                Keep up with the latest news in the OTT industry and also stay
                                to date with latest news about our Company.
                            </p>
                            <button className="readmore-btn">Read More</button>
                        </div>
                    </div>
                    <div className="divider"></div>
                    <div className="first-release">
                        <div className="first-release-title">
                            <h3>Lorem ipsum dolor sit amet, consectetur </h3>
                        </div>
                        <div className="first-release-description">
                            <p>
                                Keep up with the latest news in the OTT industry and also stay
                                to date with latest news about our Company.
                            </p>
                            <button className="readmore-btn">Read More</button>
                        </div>
                    </div>
                    <div className="divider"></div>
                </div>
            </div> */}

            <NewFooter />
        </div>
        </div>
    );
}
